import * as React from 'react';
import { useState } from 'react';
import { connect } from "react-redux";
import {FormControl, Grid, MenuItem, Select} from '@material-ui/core';
import Box from "@material-ui/core/Box";
import Help, { IHelp } from '../help/Help';
import { traducirLabel, traducirMessage } from '../../blocks/traductor';
import { enums } from "../../enums/enums";
import { loadCrucesInternacionales } from '../../redux/actions/cruceInternacionalActions';
import { ICruceInternacional } from '../../redux/types/cruceInternacionalActionTypes';
import { CruceInternacional } from '../../entities/catalogos/CruceInternacional';
import cruceInternacionalReducer from '../../redux/reducers/cruceInternacionalReducer';
import IntraUSA from './IntraUSA';
import { ApplicationState } from '../../redux/reducers';
import Sucursal from '../origenDestino/Sucursal';
import { IRecoleccion } from '../../redux/types/recoleccionActionTypes';
import NextButton from '../controls/NextButton';

interface OwnProps {
  tieneCruceFronterizo: boolean
  esInternamientoObligatorio: boolean
  onSelectCruce: (cruceFronterizo: ICruceInternacional | undefined) => void
  onClickIntraUSA: (intraUSA: boolean) => void
  cruceInicialId: number
  intraUSAInicial: boolean,
  limpiarCruceSelected: boolean,
  sucursalId?: number | null;

}

interface StateProps {
    crucesInternacionales: ICruceInternacional[]
    ayuda?: IHelp
}

interface DispatchProps {
    loadCrucesInternacionales: typeof loadCrucesInternacionales
}


type Props = OwnProps & StateProps & DispatchProps

const ServicioInternacional = (props: Props) => {
    const [cruceSeleccionado, setCruceSeleccionado] = useState("");
    const [cruceFronterizoId, setCruceFronterizoId] = useState(props.cruceInicialId);
    const [intrausa, setIntrausa] = useState(!!props.intraUSAInicial);


    const getSucursalId = (c: any) =>
        Number(c?.sucursalID ?? c?.sucursalId ?? c?.sucursalCruceId ?? 0);

    const crucesFiltrados = React.useMemo(() => {
        const sId = Number(props.sucursalId || 0);
        const lista = props.crucesInternacionales || [];

        // si no hay sucursal => catálogo completo
        if (!sId) return lista;

        // si hay sucursal => filtra por sucursal
        return lista.filter(c => getSucursalId(c) === sId);
    }, [props.crucesInternacionales, props.sucursalId]);

    React.useEffect(() => {
        setCruceFronterizoId(Number(props.cruceInicialId || 0));
    }, [props.cruceInicialId]);

    React.useEffect(() => {
        if (props.tieneCruceFronterizo && cruceSeleccionado == "") {
        if (props.crucesInternacionales.length == 0) {
            props.loadCrucesInternacionales();
        }

        if (cruceFronterizoId > 0) {
            const cruce = crucesFiltrados.find(x => x.id === cruceFronterizoId);
            props.onSelectCruce(cruce);
            console.log(cruce)
            console.log(cruceFronterizoId)
            props.onClickIntraUSA(intrausa);
            if (cruce != undefined && cruce != null)
            setCruceSeleccionado(cruce.cruce);
        }

        }
    }, [props.crucesInternacionales, crucesFiltrados]);

    React.useEffect(() => {
        if (props.limpiarCruceSelected) {
        setCruceSeleccionado("");
        setCruceFronterizoId(0);
        }
    }, [props.limpiarCruceSelected]);

    
    React.useEffect(() => {
        // si el catálogo aún no está, lo cargo y espero al próximo render
        if (props.tieneCruceFronterizo && props.crucesInternacionales.length === 0) {
        props.loadCrucesInternacionales();
        return;
        }

        const idSel = Number(cruceFronterizoId || 0);

        if (idSel > 0) {
        // busca en la MISMA lista que renderiza el combo
        const cruce = crucesFiltrados.find(x => Number(x.id) === idSel);

        if (cruce) {
            setCruceSeleccionado(cruce.cruce);
            props.onSelectCruce(cruce);
        } else {
            // el id no está en la lista filtrada (p. ej. por cambio de sucursal)
            setCruceSeleccionado("");
            props.onSelectCruce(undefined);
        }
        } else {
        // sin id seleccionado
        setCruceSeleccionado("");
        props.onSelectCruce(undefined);
        }
    }, [
        props.tieneCruceFronterizo,
        props.crucesInternacionales.length, // importante: cambia cuando llega el catálogo
        crucesFiltrados,                    // importante: cambia al filtrar por sucursal
        cruceFronterizoId                   // importante: cambia cuando te actualizan el id
    ]);



    const handleCruceFronterizo = (event) => {
        const cruceID = Number(event.target.value);
        setCruceFronterizoId(cruceID);
    }

    const handleIntraUSA = (seleccionado: boolean) => {
        setIntrausa(seleccionado);
        props.onClickIntraUSA(seleccionado);
    }

  return (<>
    <Grid container spacing={2}>
      {props.tieneCruceFronterizo &&
        <Grid item xs={12} sm={6} lg={4}>
          <strong>
            {traducirLabel(345) /* Cruce Por */}
          </strong>
          <FormControl fullWidth>
            <Select
              onChange={handleCruceFronterizo}
              fullWidth
              variant="filled"
              labelId="cruce-label"
              id="cruceInternacional"
              label={traducirLabel(345)}
              value={Number(cruceFronterizoId || 0)}
            >
              {crucesFiltrados.map(option => (
                <MenuItem key={option.id} value={Number(option.id)}> {/* número */}
                  {option.cruce}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <Box className="title-4">
            {cruceSeleccionado}
          </Box>
        </Grid>
      }
      <Grid item xs={12} sm={6} md={4}>
        <IntraUSA esSeleccionable={props.esInternamientoObligatorio} onClick={handleIntraUSA} esInternamiento={intrausa} ayuda={props.ayuda} obligatorio={props.esInternamientoObligatorio} />
      </Grid>
    </Grid>
  </>)
};

const mapStateToProps = (state: ApplicationState) => ({
    crucesInternacionales: state.crucesInternacionales
});

const mapDispatchToProps = {
    loadCrucesInternacionales: loadCrucesInternacionales
};

export default connect(mapStateToProps, mapDispatchToProps)(ServicioInternacional);